/**
 * cpSideNavigation - Directive for run metsiMenu on sidebar navigation
 */

(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpSideNavigation', cpSideNavigation);

    cpSideNavigation.$inject = ['$timeout'];

    function cpSideNavigation($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function() {
                    element.metisMenu();
                });
            }
        };
    }
})();
